<template lang="pug">
pr-wrapper(fs)
  .back.col.col-3.p-4(v-html="$t('press.backToBack')" v-visible="backButton")
  .cdv-osd(:class="{ 'no-action': !hasAction }")
    .cdv-navigation.d-flex(v-nv:scope="'cdv-scope'", @nv-back="close", data-right="cms-actions")
      .cdv-navigation-item.surface-bg.border.background.play(v-nv, @nv-enter="toggle", v-visible="isSeekable")
        icon(:icon="isPlaying ? 'fal pause' : 'fal play'")
    .cdv-actions(v-if="hasAction")
      actions(@cart="addToCart", :data="content", :data-left="isSeekable ? 'cdv-scope' : false", navigate, @nv-back="close")
</template>

<script>
import actions from "../layouts/actions.vue"
export default {
  name: "cms-detail-video",
  components: { actions },
  props: ["content", "prevRoute"],
  data() {
    return {
      isBussy: false,
      isPlaying: false,
      isSeekable: false
    }
  },
  computed: {
    backButton() {
      return __.device.config("cms_back_button_behaviour.cms_back_button_behaviour") === "enable"
    },
    hasAction() {
      return (
        (["appointment", "reservation", "request"].includes(this.content.action_type) && this.content?.endpoint !== "pms") ||
        (["product"].includes(this.content.action_type) && this.content.price)
      )
    }
  },
  async deactivated() {
    this.isBussy = false
    this.isPlaying = false
    this.isSeekable = false
  },
  async activated() {
    const res = await __.media.play(this.content.video, true)
    if (!res) return this.close()

    this.isPlaying = true
    this.isSeekable = await __.media.isSeekable()

    _$.nav.sync("cdv-scope")

    if (document.getElementById("cms-actions")?.offsetParent) _$.nav.changeScope("cms-actions")
    else _$.nav.changeScope("cdv-scope")
  },
  methods: {
    close() {
      __.platform.go(this.prevRoute)
    },
    async toggle() {
      if (this.isBussy || !this.isSeekable) return
      else this.isBussy = true

      if (this.isPlaying) await __.media.pause().then(() => (this.isPlaying = false))
      else await __.media.continue().then(() => (this.isPlaying = true))

      this.isBussy = false
    },
    addToCart(payload) {
      __.order.add(payload)
    }
  }
}
</script>

<style lang="scss" scoped>
.cdv-osd {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;

  &.no-action {
    left: auto !important;
    right: 0 !important;
    transform: translateX(0) !important;
  }

  .cdv-navigation {
    .cdv-navigation-item {
      padding: 0.5em 0.75em !important;
      margin-left: -1px;
    }
  }

  .cdv-actions {
    .cms-actions {
      margin-top: 0 !important;
    }
  }
}
</style>
